<template>
  <vx-card class="edit-user p-2 m-0"
           :class="{'main-box top-zero-radius': Object.keys(user).length === 0, 'no-box-shadow h-100': user}">
  <div class="edit-user">
    <custom-profile-image-input v-model="user.avatar" />
    <custom-validate-input :label="$t('users.general.labels.name')"
                           :classes="{'w-full': true}"
                           align="right"
                           rtl
                           :in-valid="$v.user.name.value.$invalid"
                           v-model="user.name"/>

    <custom-validate-input :label="$t('users.general.labels.family')"
                           :classes="{'w-full': true}"
                           align="right"
                           rtl
                           :in-valid="$v.user.lastName.value.$invalid"
                           v-model="user.lastName"/>

    <custom-email-input :label="$t('users.general.labels.email')"
                        :classes="{'w-full': true}"
                        :in-valid="$v.user.email.value.$invalid"
                        v-model="user.email"/>

    <vs-button id="deleteUserBTN"
               v-show="false"
               class="w-full mt-3"
               color="danger"
               v-if="$u.checkPermissions('user.delete')"
               @click="$refs.deleteConfirmation.showDialog()">
      {{ $t('users.edit.labels.deleteUser') }}
    </vs-button>

    <custom-dialog ref="deleteConfirmation"
                   :title="$t('users.general.confirmations.delete.title')"
                   :body="$t('users.general.confirmations.delete.body', { name: ` ${user.name.value} ${user.lastName.value} ` })"
                   @accept="deleteUser"/>

    <button v-show="false"
            id="EditUserBTN"
            @click="sendData"></button>
  </div>
  </vx-card>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import CustomValidateInput from '../../../components/input/customValidateInput'
import CustomEmailInput from '../../../components/input/customEmailInput'
import {deleteUser, editUser, getUser} from '../../../http/requests/users'
import CustomDialog from '../../../components/dialog/customDialog'
import CustomSelect from '../../../components/select/customSelect'
import CustomProfileImageInput from '../../../components/input/customProfileImageInput'
import CustomPhoneInput from '../../../components/input/customPhoneNumberInput.vue'
import routeMixin from '../../../mixins/route'
import {email, maxLength, required} from 'vuelidate/lib/validators'
import CustomValidateTextarea from '@/components/input/customValidateTextarea.vue'

export default {
  name: 'editUser',
  components: {
    CustomValidateTextarea,
    CustomPhoneInput,
    CustomProfileImageInput,
    CustomSelect,
    CustomDialog,
    CustomEmailInput,
    CustomValidateInput},
  props: {
    userId: {
      type: Number,
      default: 0
    },
    inModal: {
      type: Boolean,
      default: false
    }
  },
  mixins: [routeMixin],
  metaInfo () {
    return {
      title: this.user ? `${this.$t('users.edit.title')} ${this.user.name.value} ${this.user.lastName.value}` : this.$t('users.edit.title')
    }
  },
  data () {
    return {
      tabIndex: 0,
      utf8Regex: this.$u.validator('regex.utf8'),
      logs: [],
      user: {
        avatar: {
          value: '',
          isValid: true
        },
        name: {
          value: '',
          isValid: true
        },
        lastName: {
          value: '',
          isValid: true
        },
        email: {
          value: '',
          isValid: true
        },
        description: {
          value: '',
          isValid: true
        },
        role: {
          id: []
        }
      },
      roles: [],
      actions: {
        toolbar: [
          /*{
            id: 'EditUserBTN',
            icon: 'save-icon',
            iconPack: 'useral',
            color: 'success'
          }*/
        ],
        leftToolbar: [
          {
            id: 'deleteUserBTN',
            permission: 'user.delete',
            color: 'danger',
            icon: 'trash-icon',
            iconPack: 'useral'
          },
          {
            id: 'routeBackBTN',
            route: {name: this.$route.name === 'editUser' ? 'user' : 'users'},
            icon: 'chevron-left-icon',
            iconPack: 'useral'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      clubInfo: 'setting/getClubInfo',
      isMobile: 'isMobile'
    })
  },
  validations: {
    user: {
      name: {
        value: {
          required,
          maxLength: maxLength(30),
          regex (value) { return this.$u.validator('regex.user.name').test(value) }
        }
      },
      lastName: {
        value: {
          required,
          maxLength: maxLength(50),
          regex (value) { return this.$u.validator('regex.user.lastName').test(value) }
        }
      },
      email: {
        value: {
          required,
          email,
          maxLength: maxLength(50)
        }
      }
    }
  },
  created () {
    this.getUser()
    // this.getAccessGroups()
  },
  mounted () {
    if (!this.inModal) {
      this.$nextTick(() => {
        this.$store.dispatch('updateNavbarActions', this.actions)
        this.$store.dispatch('updateContentNavbarStyle', 'sticky')
      })
      this.$store.dispatch('setPageTitle', this.$t('users.edit.title'))
    }
  },
  methods: {
    getUser () {
      getUser(this.userId || this.$route.params.id, true).then(response => {
        const user = response.data.data
        this.user.editable = user.editable

        this.user.name.value = user.name || ''
        this.user.avatar.value = user.avatar || ''
        this.user.lastName.value = user.family || ''
        this.user.email.value = user.email || ''
        this.user.description.value = user.description || ''
        this.user.role = {
          label: user.role ? user.role.name : this.$t('users.edit.customer'),
          value: user.role ? user.role.id : 0,
          id: [user.role.id]
        }
        if (!this._isBeingDestroyed && !this.inModal) {
          if (this.user.editable && this.$u.checkPermissions('user.update')) {
            const actions = JSON.parse(JSON.stringify(this.actions))
            actions.toolbar = [
              {
                id: 'EditUserBTN',
                icon: 'save-icon',
                iconPack: 'useral',
                color: 'success'
              }
            ]

            this.$nextTick(() => {
              this.$store.dispatch('updateNavbarActions', actions)
            })
          }
          this.$store.dispatch('setPageTitle', `${this.$t('users.edit.title')} ${this.user.name.value} ${this.user.lastName.value}`)
        }
      })
    },
    getAccessGroups () {
      /*getRoles().then(response => {
        this.roles = this.getRoles(response.data.data)
      })*/
    },
    getRoles (role) {
      let roles = [
        {
          label: role.name,
          value: role.id
        }
      ]

      if (role.children && role.children.length > 0) {
        role.children.forEach((child) => {
          roles = [...roles, ...this.getRoles(child)]
        })
      }

      return roles
    },
    deleteUser () {
      deleteUser(this.userId || this.$route.params.id).then(() => {
        this.$vs.notify({
          title: this.$t('alert.message.title'),
          text: this.$t('users.general.notifications.delete.success'),
          color: 'success',
          time: this.$u.getReadingTime(this.$t('users.general.notifications.delete.success')),
          icon: 'icon-check',
          iconPack: 'feather'
        })
        this.$store.dispatch('helper/changeUser')
        this.$router.push({name: 'users'})
      }).catch(() => {
        this.$vs.notify({
          title: this.$t('alert.error.title'),
          text: this.$t('users.general.notifications.delete.error'),
          color: 'danger',
          time: this.$u.getReadingTime(this.$t('users.general.notifications.delete.error')),
          icon: 'icon-alert-circle',
          iconPack: 'feather'
        })
      })
    },
    sendData () {
      if (this.$v.user.$invalid) {

        this.$vs.notify({
          title: this.$t('alert.error.title'),
          text: this.$t('users.edit.validators.inputValuesIsWrong'),
          icon: 'icon-alert-circle',
          iconPack: 'feather',
          time: this.$u.getReadingTime(this.$t('users.edit.validators.inputValuesIsWrong')),
          color: 'danger'
        })
        return false
      }

      const user = {
        avatar: this.user.avatar.value,
        name: this.user.name.value,
        family: this.user.lastName.value,
        email: this.user.email.value,
        description: this.user.description.value
      }

      if (this.user.role && this.userId !== this.$store.state.auth.user.id) user.role_id = this.user.role.id[0] || null

      editUser(this.userId || this.$route.params.id, user).then(() => {
        this.$vs.notify({
          title: this.$t('alert.message.title'),
          text: this.$t('users.general.notifications.edit.success'),
          icon: 'icon-check',
          iconPack: 'feather',
          time: this.$u.getReadingTime(this.$t('users.general.notifications.edit.success')),
          color: 'success'
        })

        this.setPageHaveChange()
        this.$emit('edited')
        if (this.userId > 0) {
          this.$emit('edited')
        } else if (this.isMobile) {
          this.customRouteBack({
            name: 'user',
            params: {id: this.userId || this.$route.params.id}
          })
        }
      }).catch((error) => {
        if (axios.isCancel(error)) {
          this.$vs.notify({
            title: this.$t('alert.warning.title'),
            text: this.$t('alert.warning.repeatedRequestText'),
            icon: 'icon-alert-circle',
            iconPack: 'feather',
            time: this.$u.getReadingTime(this.$t('alert.warning.repeatedRequestText')),
            color: 'warning'
          })
        } else {
          const error_mapper = {
            'email': this.$t('users.general.notifications.parseError.email')
          }
          switch (error.response.status) {
          case 422:
            Object.keys(error.response.data.errors).forEach((error_key) => {
              const err = error_key.toString().split('.')
              if (error_mapper[err[err.length - 1]]) {
                this.$vs.notify({
                  title: this.$t('alert.message.title'),
                  text: error_mapper[err[err.length - 1]],
                  color: 'danger',
                  icon: 'icon-alert-circle',
                  iconPack: 'feather',
                  time: this.$u.getReadingTime(error_mapper[err[err.length - 1]])
                })
                error_mapper[err[err.length - 1]] = null
              } else {
                this.$vs.notify({
                  title: this.$t('alert.error.title'),
                  text: this.$t('users.general.notifications.edit.error'),
                  icon: 'icon-alert-circle',
                  iconPack: 'feather',
                  time: this.$u.getReadingTime(this.$t('users.general.notifications.edit.error')),
                  color: 'danger'
                })
              }
            })
            break

          case 403:
          case 423:
            break

          default:
            this.$vs.notify({
              title: this.$t('alert.error.title'),
              text: this.$t('users.general.notifications.edit.error'),
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: this.$u.getReadingTime(this.$t('users.general.notifications.edit.error')),
              color: 'danger'
            })
            break
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.edit-user {
  width: 100%;
  max-width: 400px;
}
</style>
